module.exports = __webpack_public_path__ + "img/4_116.84932f2f.png";